export const chevronVariants = {
  open: { rotate: 180 },
  closed: { rotate: 0 },
};

export const chevronVariantsHeader = {
  open: { rotate: 180, color: '#4da6ff' },
  closed: { rotate: 0 },
};
